import React, { useEffect, useState } from "react";
import { IoNotifications } from "react-icons/io5";
import { MdHistoryToggleOff } from "react-icons/md";
import { Layout, Menu } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { BiSolidDashboard } from "react-icons/bi";
import {
  PiDeviceMobileFill,
  PiDeviceMobileSpeakerBold,
  PiDeviceMobileSpeakerFill,
} from "react-icons/pi";
import { FaFileAlt } from "react-icons/fa";

import dashboardlogo from "../../Assests/Icons/M-POWER-logo.svg";
import Header from "./Header";
import classes from "./SideNavbar.module.css";
import { headertabs } from "../../Shared/Constants";
import logo from "../../Assests/Images/energy_monitor_logo.svg";
import maestroimg from "../../Assests/Images/maestrologo.svg";
import maelogo from "../../Assests/Images/maelogo.svg";
import rightarrow from "../../Assests/Images/right.png";
import leftarrow from "../../Assests/Images/left.png";
import consumptionimg from "../../Assests/Images/consumption.svg";
import failreimg from "../../Assests/Images/failure.svg";
import yellowconsumptionimg from "../../Assests/Images/yellowconsumption.png";
import yellowfailreimg from "../../Assests/Images/yellowfailure.png";
import { TbAlertTriangleFilled } from "react-icons/tb";
import { FaUsers } from "react-icons/fa";
import {
  CatchMessage,
  CheckUserType,
  HandleDeviceId,
  HandleMeterId,
  JSONtoformdata,
  tokenisValid,
} from "../../Shared/Methods";
import subscription from "../../Assests/Icons/subscription.png";
import colouredsubscription from "../../Assests/Icons/coloured_subscription.png";
import Usertopbackground from "../../Screens/HomeScreen/profile/UserprofileHeaderBackground";
import {
  UpdateAlertData,
  handleloading,
} from "../../Store/Redux/Reducers/Dashboardreducers";
import { useDispatch, useSelector } from "react-redux";
import { DashboardData } from "../../Services/ApiServices";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";

const { Content, Sider } = Layout;

const Sidenavbar = () => {
  let { pathname } = useLocation();
  const [open, setopen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  let navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState<any>();
  const [chartLabelData, setchartLabelData] = useState<any>();

  const dispatch = useDispatch();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [TotalDuration, setTotalDuration] = useState<any>();
  const [pinnamelist, setpinnamelist] = useState([]);

  const headeritems = [
    {
      label: "Dashboard",
      key: 1,
      icon: (
        <BiSolidDashboard
          className={
            pathname === "/dashboard"
              ? classes.coloricon
              : classes.menuicon_style
          }
        />
      ),

      className:
        !collapsed && pathname === "/dashboard" ? classes.background : "",
      pathname: "dashboard",
      onClick: () => {
        navigate("/dashboard");
      },
    },
    // {
    //   label: " Motor Dashboard",
    //   key: 2,
    //   className:
    //     !collapsed && pathname === "/motordashboard" ? classes.background : "",
    //   icon: (
    //     <BiSolidDashboard
    //       className={
    //         pathname === "/motordashboard"
    //           ? classes.coloricon
    //           : classes.menuicon_style
    //       }
    //     />
    //   ),
    //   pathname: "motordashboard",
    //   onClick: () => {
    //     navigate("/motordashboard");
    //   },
    // },
    {
      label: "Device",
      key: 3,
      className:
        !collapsed && pathname.includes("/device") ? classes.background : "",
      icon: (
        <PiDeviceMobileSpeakerBold
          className={
            pathname.includes("/device")
              ? classes.coloricon
              : classes.menuicon_style
          }
        />
      ),
      pathname: "device",
      onClick: () => {
        navigate("/device");
      },
    },

    CheckUserType()
      ? {
          label: "User",
          key: 5,
          className:
            !collapsed &&
            (pathname === "/user" || pathname === "/user/viewuser")
              ? classes.background
              : "",
          icon: (
            <FaUsers
              className={
                pathname === "/user" || pathname === "/user/viewuser"
                  ? classes.coloricon
                  : classes.menuicon_style
              }
            />
          ),
          pathname: "user",
          onClick: () => {
            navigate("/user");
          },
        }
      : null,

    {
      key: 4,
      icon: (
        <FaFileAlt
          className={
            pathname.includes("/reports")
              ? classes.coloricon
              : classes.menuicon_style
          }
        />
      ),
      label: "Reports",
      pathname: "reports",
      children: [
        {
          key: 4.1,
          icon: (
            <FaFileAlt
              className={
                pathname === "/reports/readingreport"
                  ? classes.coloricon
                  : classes.menuicon_style
              }
            />
          ),
          label: "Reading Report",
          className:
            pathname === "/reports/readingreport" ? classes.background : "",
          pathname: "/reports/readingreport",
          onClick: () => {
            navigate("/reports/readingreport");
          },
        },
        {
          key: 4.2,
          className:
            pathname === "/reports/consumptionreport" ? classes.background : "",
          icon:
            // <FaFileAlt
            //   className={
            //     pathname === "/reports/consumptionreport"
            //       ? classes.coloricon
            //       : classes.menuicon_style
            //   }
            // />
            pathname === "/reports/consumptionreport" ? (
              <img
                src={consumptionimg}
                className={classes.coloricon}
                style={{ marginTop: "4px" }}
                alt="consumptionimg"
              />
            ) : (
              <img
                src={yellowconsumptionimg}
                className={classes.menuicon_style}
                style={{ marginTop: "4px" }}
                alt="yellowconsumptionimg"
              />
            ),
          label: " Consumption Report",
          pathname: "/reports/consumptionreport",
          onClick: () => {
            navigate("/reports/consumptionreport");
          },
        },
        {
          key: 4.3,
          className:
            pathname === "/reports/historyreport" ? classes.background : "",
          icon: (
            // <FaFileAlt
            //   className={
            //     pathname === "/reports/historyreport"
            //       ? classes.coloricon
            //       : classes.menuicon_style
            //   }
            // />
            <MdHistoryToggleOff
              className={
                pathname === "/reports/historyreport"
                  ? classes.coloricon
                  : classes.menuicon_style
              }
            />
          ),
          label: "History Report",
          pathname: "/reports/historyreport",
          onClick: () => {
            navigate("/reports/historyreport");
          },
        },
        {
          key: 4.4,
          className:
            pathname === "/reports/notificationreport"
              ? classes.background
              : "",
          icon: (
            // <FaFileAlt
            //   className={
            //     pathname === "/reports/notificationreport"
            //       ? classes.coloricon
            //       : classes.menuicon_style
            //   }
            // />
            <IoNotifications
              className={
                pathname === "/reports/notificationreport"
                  ? classes.coloricon
                  : classes.menuicon_style
              }
            />
          ),
          label: "Notification Report",
          pathname: "/reports/notificationreport",
          onClick: () => {
            navigate("/reports/notificationreport");
          },
        },
        {
          key: 4.6,
          className:
            pathname === "/reports/alertreport" ? classes.background : "",
          icon: (
            <TbAlertTriangleFilled
              className={
                pathname === "/reports/alertreport"
                  ? classes.coloricon
                  : classes.menuicon_style
              }
            />
          ),
          label: "Alert Report",
          pathname: "/reports/alertreport",
          onClick: () => {
            navigate("/reports/alertreport");
          },
        },
        {
          key: 4.5,
          className:
            pathname === "/reports/failureanalysisreports"
              ? classes.background
              : "",
          icon:
            // <FaFileAlt
            //   className={
            //     pathname === "/reports/failureanalysisreports"
            //       ? classes.coloricon
            //       : classes.menuicon_style
            //   }
            // />

            pathname === "/reports/failureanalysisreports" ? (
              <img
                src={failreimg}
                className={classes.coloricon}
                style={{ marginTop: "4px" }}
                alt="failreimg"
              />
            ) : (
              <img
                src={yellowfailreimg}
                className={classes.menuicon_style}
                style={{ marginTop: "4px" }}
                alt="yellowfailreimg"
              />
            ),
          label: "Failure Analysis Report",
          pathname: "/reports/failureanalysisreports",
          onClick: () => {
            navigate("/reports/failureanalysisreports");
          },
        },
      ],
    },

    CheckUserType()
      ? {
          label: "Subscription",
          key: 6,
          className:
            !collapsed && pathname === "/subscription"
              ? classes.background
              : "",
          icon:
            pathname === "/subscription" ? (
              <img
                src={subscription}
                className={classes.coloricon}
                style={{ width: "20px" }}
                alt="failreimg"
              />
            ) : (
              <img
                src={colouredsubscription}
                className={classes.menuicon_style}
                style={{ width: "20px" }}
                alt="yellowfailreimg"
              />
            ),
          pathname: "subscription",
          onClick: () => {
            navigate("/subscription");
          },
        }
      : null,
    {
      label: "AI Reports",
      key: 7,
      className:
        !collapsed && pathname.includes("/aireports") ? classes.background : "",
      icon: (
        <PiDeviceMobileFill
          className={
            pathname.includes("/aireports")
              ? classes.coloricon
              : classes.menuicon_style
          }
        />
      ),

      pathname: "AI Reports",
      onClick: () => {
        navigate("/aireports");
      },
    },

    // {
    //   label: "User Profile",
    //   key: 5,
    //   className:
    //     !collapsed && pathname === "/user_profile" ? classes.background : "",
    //   icon:
    //     pathname === "/user_profile" ? (
    //       <img
    //         src={blackuser}
    //         className={classes.coloricon}
    //         style={{ width: "20px" }}
    //         alt="userimg"
    //       />
    //     ) : (
    //       <img
    //         src={yellowuser}
    //         className={classes.menuicon_style}
    //         style={{ width: "20px" }}
    //         alt="yellowisereimg"
    //       />
    //     ),
    //   pathname: "user_profile",
    //   onClick: () => {
    //     navigate("/user_profile");
    //   },
    // },
  ];

  const handleDashboardData = (deviceID?: any, meterID?: any) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...deviceID,
      ...meterID,
    };

    DashboardData(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          // let total_minutes = Math.floor(240 / 60) + Math.floor(120 / 60);

          // const Minutes = Math.floor(
          //   (res?.data?.data?.ideal_time_energy || 0) / 60
          // );
          // const Hours = Math.floor(Minutes / 60);
          // const TotalMinutes = Minutes % 60;

          // setTotalDuration([
          //   Math.floor((res?.data?.data?.eb_duration || 0) / 60),
          //   Math.floor((res?.data?.data?.dg_duration || 0) / 60),
          //   Math.floor((res?.data?.data?.ideal_time_energy || 0) / 60),
          // ]);

          setTotalDuration([
            Math.floor((res?.data?.data?.pin_1_duration || 0) / 60),
            Math.floor((res?.data?.data?.pin_2_duration || 0) / 60),
            Math.floor((res?.data?.data?.pin_3_duration || 0) / 60),
            Math.floor((res?.data?.data?.ideal_duration || 0) / 60),
          ]);

          // setTotalDuration([
          //   Math.floor(240 / 60),
          //   Math.floor(120 / 60),
          //   // 1440 - total_minutes,
          // ]);

          if (res?.data?.data?.pin_list?.length > 0) {
            setchartLabelData({
              ...res?.data?.data,
              pin_list: [
                ...res?.data?.data?.pin_list,
                {
                  id: 7,
                  key_name: "Idle_time",
                  pin_name: "Idle Time",
                  pin_number: 4,
                },
              ],
            });
          }

          setDashboardData(res?.data?.data);
          dispatch(UpdateAlertData(res?.data?.data));

          const pinnamelistdata = res?.data?.data?.pin_list?.map((ele: any) => {
            return ele?.pin_name;
          });

          setpinnamelist(pinnamelistdata);

          sessionStorage.setItem("AlertData", JSON.stringify(res.data.data));
        } else if (res?.data?.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <Layout hasSider>
      <Sider
        // className="sidenavbarcontainer"
        style={{
          width: "250px !important",
          minWidth: "250px",
          maxWidth: "250px",
          overflow: "auto",
          // position: "relative",
          // minHeight: "100vh",
          position: "sticky",
          height: "100vh",

          left: 0,
          top: 0,
          bottom: 0,
          background: "rgb(32, 162, 160)",
        }}
        width={240}
        // collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
      >
        {/* <Hamburger
          toggled={collapsed}
          size={20}
          toggle={() => setCollapsed(!collapsed)}
        /> */}
        <div>
          <div className={classes.logo_container}>
            <img
              src={collapsed ? logo : dashboardlogo}
              className={collapsed ? classes.logoicon : classes.logo_size}
              onClick={() => navigate("/dashboard")}
              alt="logo"
            />
            {/* <p className={classes.energy_monitoring_text}>M-POWER</p> */}
          </div>
          <Menu
            theme="dark"
            mode="inline"
            // defaultSelectedKeys={["1"]}/
            items={headeritems}
            selectedKeys={headertabs
              ?.filter((ele: any) => pathname.includes(ele?.pathname))
              ?.map((ele: any) => `${ele?.key}`)}
          />
        </div>

        <div className={classes.arrowblock}>
          <div className={classes.arrow_bg}>
            {collapsed ? (
              <img
                src={rightarrow}
                onClick={() => setCollapsed(!collapsed)}
                className={classes.arrow_style}
                alt="rightarrow"
              />
            ) : (
              <img
                src={leftarrow}
                onClick={() => setCollapsed(!collapsed)}
                className={classes.arrow_style}
                alt="leftarrow"
              />
            )}
          </div>
        </div>

        {!collapsed && (
          <div
            className={classes.logoblock}
            // style={{ left: collapsed ? "1%" : "2%" }}
          >
            <img
              src={collapsed ? maelogo : maestroimg}
              alt="maestro"
              className={collapsed ? classes.maelogo : classes.logoiconmae}
            />
          </div>
        )}
      </Sider>
      <Layout
      // className={!collapsed ? "sidenavbarlayout" : "sidenavbarColapsedLayout"}
      >
        <div className="main_container_width">
          <div className={classes.layout_background}>
            <Header
              setopen={setopen}
              open={open}
              handleDashboardData={handleDashboardData}
            />

            <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
              {pathname === "/user_profile" ? <Usertopbackground /> : null}

              <div
                className="main_cointainer"
                // style={pathname === "/user_profile" ? { padding: 0 } : {}}
              >
                <Outlet
                  context={{
                    dashboardData: dashboardData,
                    handleDashboardData: handleDashboardData,
                    TotalDuration: TotalDuration,
                    pinnamelist: pinnamelist || [],
                    chartLabelData: chartLabelData,
                  }}
                />
              </div>
            </Content>
          </div>
        </div>
      </Layout>
    </Layout>
  );
};

export default Sidenavbar;
